import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../base/i18n';

import AddDocumentButton from './AddDocumentButton';
import ShareDocumentList from './ShareDocumentList';

import { CanvasLayout, CanvasTool } from '../../base/canvas';
import { isCheckPermission } from '../../base/localuser/functions';
import { PERMISSION } from '../../base/participants';

import { getCurrentMode, videoLayoutMode } from '../../video-layout-mode';
import DocumentLeft from './DocumentLeft';

function ShareDocumentLayout({
    t, shareDocumentPermission, isWhiteBoard, mode, resize,
    mobile, expand, isLeftOpen, setLeftOpen 
}) {
    
    return (
        <div className={`addition_layout share_document_layout left_${expand}`}>
            <DocumentLeft mobile={mobile} expand={expand} isLeftOpen={isLeftOpen} 
                name={isWhiteBoard ? t("document.whiteBoard") : t("document.shareDocument")}>
                {shareDocumentPermission && (
                    <AddDocumentButton t={t} isWhiteBoard={isWhiteBoard} />
                )}

                <ShareDocumentList shareDocumentPermission={shareDocumentPermission} isWhiteBoard={isWhiteBoard} />
            </DocumentLeft>

            <CanvasTool isLeftOpen={isLeftOpen} setLeftOpen={setLeftOpen} />
            
            <CanvasLayout shareDocumentPermission={shareDocumentPermission} resize={resize} isWhiteBoard={isWhiteBoard} expand={expand} isLeftOpen={isLeftOpen} />
        </div>
    );
}

function _mapStateToProps(state) {
    const shareDocumentPermission = isCheckPermission(state, PERMISSION.SHARE);
    const mode = getCurrentMode(state);
    const isWhiteBoard = mode === videoLayoutMode.document ? false : true;

    return {
        shareDocumentPermission,
        isWhiteBoard
    };
}

export default translate(connect(_mapStateToProps)(ShareDocumentLayout));
